import React, { Fragment, ReactElement } from "react";
import { TextBox } from "./InputBoxes";

interface ITextInputList {
  value: string;
  onChange: (selectedValue: string) => void;
}

export const TextInputList = (props: ITextInputList): ReactElement => {
  return (
    <Fragment>
      <TextBox onChange={props.onChange} value={props.value} />
    </Fragment>
  );
};
